// extracted by mini-css-extract-plugin
export default {"link":"AboutMe_link__+pBi+","button":"AboutMe_button__opLy6","list":"AboutMe_list__q+Mt3"};